import { render, staticRenderFns } from "./MetasInput.vue?vue&type=template&id=4a200276&scoped=true"
import script from "./MetasInput.vue?vue&type=script&lang=js"
export * from "./MetasInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a200276",
  null
  
)

export default component.exports